import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onClick"];
import useUsageTracker from '../hooks/useUsageTracker';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackedLink = _ref => {
  let {
      children,
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    trackNotificationsClick
  } = useUsageTracker();
  const trackedOnClick = evt => {
    trackNotificationsClick(evt);
    if (onClick) {
      return onClick(evt);
    }
    return undefined;
  };
  return /*#__PURE__*/_jsx(Link, Object.assign({
    onClick: trackedOnClick
  }, rest, {
    children: children
  }));
};
export default TrackedLink;